import { updateViewRequest } from 'modules/messagingInsights/actions';
import { useViewContext } from 'modules/messagingInsights/context/ViewContext';
import {
  selectCreateViewLoading,
  selectSavedView,
  selectUpdateViewLoading,
} from 'modules/messagingInsights/selectors';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button, BUTTON_SIZES } from 'ui/button';
import { Save24 } from 'ui/icons';
import { spacing } from 'ui/theme';
import { NoOp } from 'utils/noop';
import { useViewsModals } from './hooks/useViewsModals';
import { CreateOrEditViewModal } from './modals/CreateOrEditViewModal';
import { useGetCurrSettings } from './hooks/useGetCurrSettings';
import { useGetUnsavedSettings } from './hooks/useGetUnsavedSettings';

const StyledButton = styled(Button)`
  width: 100%;
`;

export const SaveViewButton = () => {
  const dispatch = useDispatch();
  // View states
  const { viewId } = useViewContext();
  const currSettings = useGetCurrSettings();
  const unsavedSettings = useGetUnsavedSettings();
  const view = useSelector(selectSavedView);

  // Loading states
  const updateLoading = useSelector(selectUpdateViewLoading);
  const createLoading = useSelector(selectCreateViewLoading);
  const loading = createLoading || updateLoading;

  // Modal states
  const modals = useViewsModals();
  const modalIsOpen = modals.create.isShown || modals.edit.isShown;

  const handleSaveView: NoOp = () => {
    if (viewId) {
      dispatch(updateViewRequest({ ...view, settings: currSettings }));
    } else {
      modals.create.toggle(true);
    }
  };

  return (
    <>
      <StyledButton
        onClick={handleSaveView}
        isDisabled={modalIsOpen || (view && !unsavedSettings)}
        size={BUTTON_SIZES.LARGE}
        isLoading={loading}
      >
        <Save24 width={spacing.plusHalf} height={spacing.plusHalf} />
        <span>{viewId && view ? 'Save changes' : 'Save view'}</span>
      </StyledButton>
      {modalIsOpen && <CreateOrEditViewModal />}
    </>
  );
};
